import { AppAction } from '@shared/extension/enums';
import { dispatchAppDocumentEvent, unloadOnOrphaned } from '@shared/extension/utils/events';
import { ONE_WEEK_MS } from '@shared/utils/constants/time';

const LETTERS_REGEX = /[a-zA-Z]/;
const COMMA_NOTIFICATION_DISPLAY_TIME_INTERVAL = ONE_WEEK_MS * 4;
const COMMA_NOTIFICATION_DISPLAY_TIME_STORAGE_KEY = 'CommaNotificationDisplayTime';

class LearningInputValidation {
  private commaNotificationDisplayTime: number | null = null;

  constructor() {
    const commaNotificationDisplayTimeValue: string | null = localStorage.getItem(
      COMMA_NOTIFICATION_DISPLAY_TIME_STORAGE_KEY
    );
    if (commaNotificationDisplayTimeValue) {
      this.commaNotificationDisplayTime = parseInt(commaNotificationDisplayTimeValue);
    }
    this.init();
  }

  removeEventListeners(): void {
    document.removeEventListener('input', this.handleInput);
  }

  private init(): void {
    document.addEventListener('input', this.handleInput.bind(this));
  }

  private handleInput(event: InputEvent): void {
    const target = event.target as HTMLInputElement;
    if (!target || target.tagName !== 'INPUT') {
      return;
    }
    const value: string = target.value;
    if (
      !!value &&
      value.includes(',') &&
      !LETTERS_REGEX.test(value) &&
      (!this.commaNotificationDisplayTime ||
        Date.now() - this.commaNotificationDisplayTime >= COMMA_NOTIFICATION_DISPLAY_TIME_INTERVAL)
    ) {
      this.displayNotification();
    }
  }

  private displayNotification(): void {
    this.commaNotificationDisplayTime = Date.now();
    localStorage.setItem(COMMA_NOTIFICATION_DISPLAY_TIME_STORAGE_KEY, this.commaNotificationDisplayTime.toString());
    dispatchAppDocumentEvent(
      new CustomEvent(AppAction.ShowNotificationPopup, {
        detail: {
          title: 'extension.learning_input_validation.labels.title',
          message: [
            'extension.learning_input_validation.labels.message',
            'extension.learning_input_validation.labels.example',
          ],
        },
      })
    );
  }
}

const instance = new LearningInputValidation();

unloadOnOrphaned('install-learning-input-validation-script', () => {
  instance.removeEventListeners();
});
